package com.example.mystybag.login.views.views

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.example.mystybag.common.extensions.keyboardPadding
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.expected.rememberIsWebPortraitLayout
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.login.logic.MerchantRegistrationAddCompanyDetailsViewModel
import com.example.mystybag.login.views.components.MerchantRegistrationWebBoundedColumn

@Composable
fun MerchantRegistrationAddCompanyDetailsWebView(
    viewModel: MerchantRegistrationAddCompanyDetailsViewModel
) {
    val webPortrait = rememberIsWebPortraitLayout()
    UIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        horizontalAlignment = Alignment.Start
    ) { _ ->
        MerchantRegistrationWebBoundedColumn(Modifier.fillMaxSize()) {
            if (webPortrait) {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .keyboardPadding()
                        .padding(bottom = p8)
                ) {
                    Column(
                        modifier = Modifier
                            .weight(1f)
                            .fillMaxWidth()
                            .fillMaxHeight()
                            .verticalScroll(rememberScrollState())
                    ) {
                        MerchantRegistrationAddCompanyDetailsTopSection(
                            viewModel = viewModel,
                            includeSpacerAfterBulstat = true
                        )
                    }
                    MerchantRegistrationAddCompanyDetailsFooterSection(viewModel)
                }
            } else {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .verticalScroll(rememberScrollState())
                        .keyboardPadding()
                        .padding(bottom = p8)
                ) {
                    MerchantRegistrationAddCompanyDetailsTopSection(
                        viewModel = viewModel,
                        includeSpacerAfterBulstat = false
                    )
                    MerchantRegistrationAddCompanyDetailsFooterSection(viewModel)
                }
            }
        }
    }
}
